import {
  type ResolveColorOrderInput as ResolveSwimlaneColorsInput,
  type ResolveColorOrderOutput as ResolveSwimlaneColorsOutput,
  resolveColorOrder,
} from '@tempo-io/loop-visualization-color-resolver';

export type { ResolveSwimlaneColorsInput, ResolveSwimlaneColorsOutput };

export function resolveSwimlaneColors(
  input: ResolveSwimlaneColorsInput,
): ResolveSwimlaneColorsOutput {
  return resolveColorOrder(input);
}
